import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { ListagemFaturamentoContratoGrupoDTO } from './dto/listagem-faturamento-contrato-grupo.dto';

@Injectable()
export class ContratoGrupoRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.CONTRATOS_GRUPOS);
  }

  filter(search: string) {
    return this.getRequest<{ data: { results: any[]; count: number } }>({
      search,
      page: 1,
      offset: 0,
      limit: 10,
    }).pipe(
      map(({ data }) =>
        data.results.map((item) => ({
          label: String(item.numeroGrupoContrato),
          value: String(item.id),
        })),
      ),
    );
  }

  listagemFaturamento(params: ListagemFaturamentoContratoGrupoDTO) {
    return this.customClient.post(ApiResources.CONTRATOS_GRUPOS_LISTAGEM_FATURAMENTO, {
      Clientes: params.clienteIds,
      GruposContratos: params.grupoContratoIds,
      page: params.page,
      limit: params.limit,
      Situacoes: ['2'],
      TipoContrato: 'T',
      GerarMedicao: 'S',
      SituacoesMedicao: params.situacoesMedicao,
      Empresas: [],
      DataInicio: null,
      DataTermino: null,
    })
    .pipe(this.mapperData());
  }
}
